import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconCallCenter: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.3 8.3C19.2 4.6 15.9 2 12 2C8.1 2 4.8 4.6 3.7 8.3C2.7 8.8 2 9.8 2 11V14C2 15.7 3.3 17 5 17H8C8.6 17 9 16.6 9 16V9C9 8.4 8.6 8 8 8H6C7 5.6 9.4 4 12 4C14.7 4 17 5.6 18 8H16C15.4 8 15 8.4 15 9V16C15 16.6 15.4 17 16 17H17.8C17.4 18.2 16.3 19 15 19H13.7C13.4 18.4 12.7 18 12 18C10.9 18 10 18.9 10 20C10 21.1 10.9 22 12 22C12.7 22 13.4 21.6 13.7 21H15C17.5 21 19.5 19.2 19.9 16.8C21.1 16.4 22 15.3 22 14V11C22 9.8 21.3 8.8 20.3 8.3ZM7 15H5C4.4 15 4 14.6 4 14V11C4 10.4 4.4 10 5 10H7V15ZM20 14C20 14.6 19.6 15 19 15H17V10H19C19.6 10 20 10.4 20 11V14Z',
    })
  )
}
